import { testimonials } from '../../../mocks/testimonials';

export default function CourseTestimonials() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 px-4 py-2 bg-orange-50 text-orange-600 text-sm font-semibold rounded-full mb-4">
            <i className="ri-chat-smile-3-line w-4 h-4 flex items-center justify-center"></i>
            Depoimentos Reais
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            O que dizem nossos alunos
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Professores de todo o Brasil já transformaram suas aulas com nosso curso
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.slice(0, 6).map((t, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm border border-gray-100 hover:shadow-lg hover:border-orange-200 transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-amber-400 text-sm w-4 h-4 flex items-center justify-center"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 leading-relaxed mb-6 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-orange-400 to-amber-400 flex items-center justify-center">
                  <span className="text-white text-sm font-bold">{t.name.charAt(0)}</span>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">{t.name}</p>
                  <p className="text-xs text-gray-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}